<div class="container-content" fxLayout="column">
  <h1 class="fs-2 fw-bold">{{ 'label.profile-edit' | translate }}</h1>
  <app-profile-edit-form></app-profile-edit-form>
</div>
